/**
 * Вспомогательные функции для отображения карточке и списков
 */

const getPredicateValue = (item) => {
  return ( item?.predicat?.value || item?.predicate?.value || '');
};

const getExistingPredicateSet = (values) => {
  if (!Array.isArray(values)) return new Set();
  return new Set(
    values
      .map(getPredicateValue)
      .filter(Boolean)
  );
};

/** Функция, которая фильтрует addedPredicates, исключая из addedPredicates те предикаты, 
 * которые есть в value. 
 * Используется после добавления свойства в карточку и сохранения */
export const filterAddedPredicates = (addedPredicates, values) => {
  const existingPredicateSet = getExistingPredicateSet(values);

  return (addedPredicates || []).filter((item) => {
    const predicateIri = getPredicateValue(item);
    return predicateIri && !existingPredicateSet.has(predicateIri);
  });
};
